import * as types from "../../mutation-types";
import statistika from "./statistika";
import prijem from "./prijem";
import pretraga from "./pretraga";
import obrada from "./obrada";
import nalazi from "./nalazi";
import narucioci from "./narucioci"; // Group email
import reports from "./reports";
import analize from "./analize";
import kontrole from "./kontrole";
import thermometer from "./loger";
import mikrobiologija from "./mikrobiologija";
import postavke from "./postavke";
import excel from "./excel";
import analysers from "./analysers";
import assays from "./assays";

const state = {
  items: [
    statistika,
    prijem,
    pretraga,
    obrada,
    nalazi,
    narucioci, // Group email
    reports,
    analize,
    // kontrole,
    // thermometer,
    // mikrobiologija,
    postavke,
    // excel,
    analysers,
    assays
  ]
};

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM](state, payload) {
    let menuItem = payload.menuItem;
    let expand = payload.expand;
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand;
    }
  }
};

const actions = {
  toggleExpandMenuItem({ commit }, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload);
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js